/**
 * Copyright (c) 2020-2023 ForgeRock. All rights reserved.
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */

import { createRouter, createWebHashHistory } from 'vue-router';

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('@/views/Login'),
      meta: { title: 'Login' }
    },
    {
      path: '/logout',
      name: 'logout',
    },
    {
      path: '/service/:tree',
      name: 'service',
      component: () => import('@/views/Login'),
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: () => import(/* webpackChunkName: "forbidden" */ '@/views/Forbidden'),
    },
    {
      // send any bad routes to default login
      path: '/:pathMatch(.*)*',
      redirect: '/',
    },
    {
      path: '/redirect',
      name: 'Redirect',
      component: () => import('@/views/Redirect'),
    }
  ],
});

router.afterEach((to) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
});

export default router;
